export default [
  { text: 'sales.table.name', sortable: false, value: 'name', align: 'left' },
  { text: 'sales.table.sales', value: 'sales', align: 'left' },
  { text: 'sales.table.total', value: 'total', align: 'left' },
  { text: 'sales.table.cat', sortable: false, value: 'category', align: 'left' },
];
